import { LOCALE_STRING_NAMES, PhoenixLocale } from '../model/locale';

export const isLocale = (val: string | PhoenixLocale): val is PhoenixLocale => LOCALE_STRING_NAMES.includes(val);
